import React from 'react';
import Piano from './components/Piano';

function App() {
  return (
    <div className="App">
      <Piano />
    </div>
  );
}

export default App;
